import Cookies from "js-cookie";
import React, { createContext, useEffect, useRef, useState } from "react";
import { useUserPermissions } from "../../../UserPermissionsContext";

interface InactivityContextType {
  isIdle: boolean;
  isStatusChange: boolean;
  setIsStatusChange: (status: boolean) => void; // Function to update isStatusChange
  isProfileChange: boolean;
  setIsprofileChange: (status: boolean) => void;
  selectedClass: string;
  setSelectedClass: (Class: string) => void;
  selectedBranch: string;
  setSelectedBranch: (branch: string) => void;
  selectedBranchName: string;
  setSelectedBranchName: (branch: string) => void;
  selectedClassName: string;
  setSelectedClassName: (className: string) => void;
  wizklubPreviousYearselectedBranch: string;
  setWizklubPreviousYearSelectedBranch: (className: string) => void;
  wizklubPreviousYearselectedClass: string;
  setWizklubPreviousYearSelectedClass: (className: string) => void;
  wizklubPreviousYearselectedBranchName: string;
  setWizklubPreviousYearSelectedBranchName: (branch: string) => void;
  wizklubPreviousYearselectedClassName: string;
  setWizklubPreviousYearSelectedClassName: (branch: string) => void;
  wizklubStudentsSelectedAdmissionStatus: string;
  setWizklubStudentsSelectedAdmissionStatus: (branch: string) => void;
  wizklubStudentsSelectedAdmissionStatusName: string;
  setWizklubStudentsSelectedAdmissionStatusName: (branch: string) => void;
  wizklubCallBackSelectedClass: string;
  setWizklubCallBackSelectedClass: (branch: string) => void;
  wizklubCallBackSelectedBranch: string;
  setWizklubCallBackSelectedBranch: (branch: string) => void;
  wizklubCallBackSelectedBranchName: string;
  setWizklubCallBackSelectedBranchName: (branch: string) => void;
  wizklubCallBackSelectedClassName: string;
  setWizklubCallBackSelectedClassName: (branch: string) => void;
  wizklubCallBackSelectedCategory: string;
  setWizklubCallBackSelectedCategory: (branch: string) => void;
  wizklubCallBackSelectedSubCategory: string;
  setWizklubCallBackSelectedSubCategory: (branch: string) => void;
  wizklubCallBackSelectedAgent: string;
  setWizklubCallBackSelectedAgent: (branch: string) => void;
  wizklubCallBackSelectedCategoryName: string;
  setWizklubCallBackSelectedCategoryName: (branch: string) => void;
  wizklubCallBackSelectedSubCategoryName: string;
  setWizklubCallBackSelectedSubCategoryName: (branch: string) => void;
  wizklubCallBackSelectedAgentName: string;
  setWizklubCallBackSelectedAgentName: (branch: string) => void;
  wizklubCompletedSelectedClass: string;
  setWizklubCompletedSelectedClass: (branch: string) => void;
  wizklubCompletedSelectedBranch: string;
  setWizklubCompletedSelectedBranch: (branch: string) => void;
  wizklubCompletedSelectedBranchName: string;
  setWizklubCompletedSelectedBranchName: (branch: string) => void;
  wizklubCompletedSelectedClassName: string;
  setWizklubCompletedSelectedClassName: (branch: string) => void;
  wizklubCompletedSelectedAgent: string;
  setWizklubCompletedSelectedAgent: (branch: string) => void;
  wizklubCompletedSelectedAgentName: string;
  setWizklubCompletedSelectedAgentName: (branch: string) => void;
  wizklubSelectedAgentName: string;
  setWizklubSelectedAgentName: (branch: string) => void;
  wizklubSelectedAgent: string;
  setWizklubSelectedAgent: (branch: string) => void;
  wizklubCompletedSelectedCategory: string;
  setWizklubCompletedSelectedCategory: (branch: string) => void;
  wizklubCompletedSelectedSubCategory: string;
  setWizklubCompletedSelectedSubCategory: (branch: string) => void;
  wizklubCompletedSelectedCategoryName: string;
  setWizklubCompletedSelectedCategoryName: (branch: string) => void;
  wizklubCompletedSelectedSubCategoryName: string;
  setWizklubCompletedSelectedSubCategoryName: (branch: string) => void;
  summerCampSelectedClass: string;
  setSummerCampSelectedClass: (branch: string) => void;
  summerCampSelectedBranch: string;
  setSummerCampSelectedBranch: (branch: string) => void;
  summerCampSelectedBranchName: string;
  setSummerCampSelectedBranchName: (branch: string) => void;
  summerCampSelectedClassName: string;
  setSummerCampSelectedClassName: (branch: string) => void;
  summerCampPendingSelectedClass: string;
  setSummerCampPendingSelectedClass: (branch: string) => void;
  summerCampPendingSelectedBranch: string;
  setSummerCampPendingSelectedBranch: (branch: string) => void;
  summerCampPendingSelectedBranchName: string;
  setSummerCampPendingSelectedBranchName: (branch: string) => void;
  summerCampPendingSelectedClassName: string;
  setSummerCampPendingSelectedClassName: (branch: string) => void;
  summerCampTargetsSelectedClass: string;
  setSummerCampTargetsSelectedClass: (branch: string) => void;
  summerCampTargetsSelectedBranch: string;
  setSummerCampTargetsSelectedBranch: (branch: string) => void;
  summerCampTargetsSelectedBranchName: string;
  setSummerCampTargetsSelectedBranchName: (branch: string) => void;
  summerCampTargetsSelectedClassName: string;
  setSummerCampTargetsSelectedClassName: (branch: string) => void;
  summerCampCallBackSelectedClass: string;
  setSummerCampCallBackSelectedClass: (branch: string) => void;
  summerCampCallBackSelectedBranch: string;
  setSummerCampCallBackSelectedBranch: (branch: string) => void;
  summerCampCallBackSelectedBranchName: string;
  setSummerCampCallBackSelectedBranchName: (branch: string) => void;
  summerCampCallBackSelectedClassName: string;
  setSummerCampCallBackSelectedClassName: (branch: string) => void;
  summerCampCallBackSelectedCategory: string;
  setSummerCampCallBackSelectedCategory: (branch: string) => void;
  summerCampCallBackSelectedSubCategory: string;
  setSummerCampCallBackSelectedSubCategory: (branch: string) => void;
  summerCampCallBackSelectedAgent: string;
  setSummerCampCallBackSelectedAgent: (branch: string) => void;
  summerCampCallBackSelectedCategoryName: string;
  setSummerCampCallBackSelectedCategoryName: (branch: string) => void;
  summerCampCallBackSelectedSubCategoryName: string;
  setSummerCampCallBackSelectedSubCategoryName: (branch: string) => void;
  summerCampCallBackSelectedAgentName: string;
  setSummerCampCallBackSelectedAgentName: (branch: string) => void;
  wizklubSalesSelectedClass: string;
  setWizklubSalesSelectedClass: (branch: string) => void;
  wizklubSalesSelectedBranch: string;
  setWizklubSalesSelectedBranch: (branch: string) => void;
  wizklubSalesSelectedBranchName: string;
  setWizklubSalesSelectedBranchName: (branch: string) => void;
  wizklubSalesSelectedClassName: string;
  setWizklubSalesSelectedClassName: (branch: string) => void;
  wizklubSalesSelectedAgent: string;
  setWizklubSalesSelectedAgent: (branch: string) => void;
  wizklubSalesSelectedAgentName: string;
  setWizklubSalesSelectedAgentName: (branch: string) => void;
  summerCampCompletedSelectedClass: string;
  setSummerCampCompletedSelectedClass: (branch: string) => void;
  summerCampCompletedSelectedBranch: string;
  setSummerCampCompletedSelectedBranch: (branch: string) => void;
  summerCampCompletedSelectedBranchName: string;
  setSummerCampCompletedSelectedBranchName: (branch: string) => void;
  summerCampCompletedSelectedClassName: string;
  setSummerCampCompletedSelectedClassName: (branch: string) => void;
  summerCampCompletedSelectedAgent: string;
  setSummerCampCompletedSelectedAgent: (branch: string) => void;
  summerCampCompletedSelectedAgentName: string;
  setSummerCampCompletedSelectedAgentName: (branch: string) => void;
  summerCampCompletedSelectedCategory: string;
  setSummerCampCompletedSelectedCategory: (branch: string) => void;
  summerCampCompletedSelectedSubCategory: string;
  setSummerCampCompletedSelectedSubCategory: (branch: string) => void;
  summerCampCompletedSelectedCategoryName: string;
  setSummerCampCompletedSelectedCategoryName: (branch: string) => void;
  summerCampCompletedSelectedSubCategoryName: string;
  setSummerCampCompletedSelectedSubCategoryName: (branch: string) => void;
  wizklubSalesState: string;
  setWizklubSalesState: (branch: string) => void;
  wizklubSalesZone: string;
  setWizklubSalesZone: (branch: string) => void;
  wizklubSalesStateName: string;
  setWizklubSalesStateName: (branch: string) => void;
  wizklubSalesZoneName: string;
  setWizklubSalesZoneName: (branch: string) => void;
}

export const InactivityContext = createContext<
  InactivityContextType | undefined
>(undefined);

export const InactivityProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isIdle, setIsIdle] = useState(false);
  const [isStatusChange, setIsStatusChange] = useState(false); // State for status change
  const [isProfileChange, setIsprofileChange] = useState(false);
  const [selectedClass, setSelectedClass] = useState<string>("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedBranchName, setSelectedBranchName] = useState<string>("");
  const [selectedClassName, setSelectedClassName] = useState<string>("");
  const [wizklubStudentsSelectedAdmissionStatus, setWizklubStudentsSelectedAdmissionStatus] = useState<string>("");
  const [wizklubStudentsSelectedAdmissionStatusName, setWizklubStudentsSelectedAdmissionStatusName] = useState<string>("");
  const [wizklubCallBackSelectedClass, setWizklubCallBackSelectedClass] = useState<string>("");
  const [wizklubCallBackSelectedBranch, setWizklubCallBackSelectedBranch] = useState("");
  const [wizklubCallBackSelectedBranchName, setWizklubCallBackSelectedBranchName] = useState<string>("");
  const [wizklubCallBackSelectedClassName, setWizklubCallBackSelectedClassName] = useState<string>("");
  const [wizklubCallBackSelectedCategory, setWizklubCallBackSelectedCategory] = useState<string>("");
  const [wizklubCallBackSelectedSubCategory, setWizklubCallBackSelectedSubCategory] = useState<string>("");
  const [wizklubCallBackSelectedAgent, setWizklubCallBackSelectedAgent] = useState<string>("");
  const [wizklubCallBackSelectedCategoryName, setWizklubCallBackSelectedCategoryName] = useState<string>("");
  const [wizklubCallBackSelectedSubCategoryName, setWizklubCallBackSelectedSubCategoryName] = useState<string>("");
  const [wizklubCallBackSelectedAgentName, setWizklubCallBackSelectedAgentName] = useState<string>("");
  const [wizklubCompletedSelectedClass, setWizklubCompletedSelectedClass] = useState<string>("");
  const [wizklubCompletedSelectedBranch, setWizklubCompletedSelectedBranch] = useState("");
  const [wizklubCompletedSelectedBranchName, setWizklubCompletedSelectedBranchName] = useState<string>("");
  const [wizklubCompletedSelectedClassName, setWizklubCompletedSelectedClassName] = useState<string>("");
  const [wizklubCompletedSelectedAgent, setWizklubCompletedSelectedAgent] = useState<string>("");
  const [wizklubCompletedSelectedAgentName, setWizklubCompletedSelectedAgentName] = useState<string>("");
  const [wizklubSelectedAgent, setWizklubSelectedAgent] = useState<string>("");
  const [wizklubSelectedAgentName, setWizklubSelectedAgentName] = useState<string>("");
  const [wizklubCompletedSelectedCategory, setWizklubCompletedSelectedCategory] = useState<string>("");
  const [wizklubCompletedSelectedSubCategory, setWizklubCompletedSelectedSubCategory] = useState<string>("");
  const [wizklubCompletedSelectedCategoryName, setWizklubCompletedSelectedCategoryName] = useState<string>("");
  const [wizklubCompletedSelectedSubCategoryName, setWizklubCompletedSelectedSubCategoryName] = useState<string>("");
  const [summerCampSelectedClass, setSummerCampSelectedClass] = useState<string>("");
  const [summerCampSelectedBranch, setSummerCampSelectedBranch] = useState("");
  const [summerCampSelectedBranchName, setSummerCampSelectedBranchName] = useState<string>("");
  const [summerCampSelectedClassName, setSummerCampSelectedClassName] = useState<string>("");
  const [summerCampPendingSelectedClass, setSummerCampPendingSelectedClass] = useState<string>("");
  const [summerCampPendingSelectedBranch, setSummerCampPendingSelectedBranch] = useState("");
  const [summerCampPendingSelectedBranchName, setSummerCampPendingSelectedBranchName] = useState<string>("");
  const [summerCampPendingSelectedClassName, setSummerCampPendingSelectedClassName] = useState<string>("");
  const [summerCampTargetsSelectedClass, setSummerCampTargetsSelectedClass] = useState<string>("");
  const [summerCampTargetsSelectedBranch, setSummerCampTargetsSelectedBranch] = useState("");
  const [summerCampTargetsSelectedBranchName, setSummerCampTargetsSelectedBranchName] = useState<string>("");
  const [summerCampTargetsSelectedClassName, setSummerCampTargetsSelectedClassName] = useState<string>("");
  const [summerCampCallBackSelectedClass, setSummerCampCallBackSelectedClass] = useState<string>("");
  const [summerCampCallBackSelectedBranch, setSummerCampCallBackSelectedBranch] = useState("");
  const [summerCampCallBackSelectedBranchName, setSummerCampCallBackSelectedBranchName] = useState<string>("");
  const [summerCampCallBackSelectedClassName, setSummerCampCallBackSelectedClassName] = useState<string>("");
  const [summerCampCallBackSelectedCategory, setSummerCampCallBackSelectedCategory] = useState<string>("");
  const [summerCampCallBackSelectedSubCategory, setSummerCampCallBackSelectedSubCategory] = useState<string>("");
  const [summerCampCallBackSelectedAgent, setSummerCampCallBackSelectedAgent] = useState<string>("");
  const [summerCampCallBackSelectedCategoryName, setSummerCampCallBackSelectedCategoryName] = useState<string>("");
  const [summerCampCallBackSelectedSubCategoryName, setSummerCampCallBackSelectedSubCategoryName] = useState<string>("");
  const [summerCampCallBackSelectedAgentName, setSummerCampCallBackSelectedAgentName] = useState<string>("");
  const [wizklubSalesSelectedClass, setWizklubSalesSelectedClass] = useState<string>("");
  const [wizklubSalesSelectedBranch, setWizklubSalesSelectedBranch] = useState("");
  const [wizklubSalesSelectedBranchName, setWizklubSalesSelectedBranchName] = useState<string>("");
  const [wizklubSalesSelectedClassName, setWizklubSalesSelectedClassName] = useState<string>("");
  const [wizklubSalesSelectedAgent, setWizklubSalesSelectedAgent] = useState<string>("");
  const [wizklubSalesSelectedAgentName, setWizklubSalesSelectedAgentName] = useState<string>("");
  const [summerCampCompletedSelectedClass, setSummerCampCompletedSelectedClass] = useState<string>("");
  const [summerCampCompletedSelectedBranch, setSummerCampCompletedSelectedBranch] = useState("");
  const [summerCampCompletedSelectedBranchName, setSummerCampCompletedSelectedBranchName] = useState<string>("");
  const [summerCampCompletedSelectedClassName, setSummerCampCompletedSelectedClassName] = useState<string>("");
  const [summerCampCompletedSelectedAgent, setSummerCampCompletedSelectedAgent] = useState<string>("");
  const [summerCampCompletedSelectedAgentName, setSummerCampCompletedSelectedAgentName] = useState<string>("");
  const [summerCampCompletedSelectedCategory, setSummerCampCompletedSelectedCategory] = useState<string>("");
  const [summerCampCompletedSelectedSubCategory, setSummerCampCompletedSelectedSubCategory] = useState<string>("");
  const [summerCampCompletedSelectedCategoryName, setSummerCampCompletedSelectedCategoryName] = useState<string>("");
  const [summerCampCompletedSelectedSubCategoryName, setSummerCampCompletedSelectedSubCategoryName] = useState<string>("");
  const [wizklubSalesState, setWizklubSalesState] = useState<string>("");
  const [wizklubSalesZone, setWizklubSalesZone] = useState<string>("");
  const [wizklubSalesStateName, setWizklubSalesStateName] = useState<string>("");
  const [wizklubSalesZoneName, setWizklubSalesZoneName] = useState<string>("");
  const [
    wizklubPreviousYearselectedBranch,
    setWizklubPreviousYearSelectedBranch,
  ] = useState("");
  const [
    wizklubPreviousYearselectedClass,
    setWizklubPreviousYearSelectedClass,
  ] = useState<string>("");
  const [
    wizklubPreviousYearselectedBranchName,
    setWizklubPreviousYearSelectedBranchName,
  ] = useState<string>("");
  const [
    wizklubPreviousYearselectedClassName,
    setWizklubPreviousYearSelectedClassName,
  ] = useState<string>("");
  const timeoutId = useRef<number | null>(null); // Use useRef to persist timeoutId
  const jwtToken = Cookies.get("authToken");
  const { webApi } = useUserPermissions();

  // Reset inactivity timer
  const resetTimer = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    setIsIdle(false);
    timeoutId.current = window.setTimeout(() => {
      setIsIdle(true);
      // handleLogout(); // Call logout when idle
    }, 300000); // 300 seconds (5 minutes)
  };

  // const resetTimer = () => {
  //   if (timeoutId.current) {
  //     clearTimeout(timeoutId.current);
  //   }
  //   setIsIdle(false);
  //   timeoutId.current = window.setTimeout(() => {
  //     setIsIdle(true);
  //     // handleLogout(); // Call logout when idle
  //   }, 3000); // 300 seconds (5 minutes)
  // };

  // const resetTimer = () => {
  //   clearTimeout(timeoutId);
  //   setIsIdle(false);
  //   timeoutId = window.setTimeout(() => {
  //     setIsIdle(true);
  //   }, 5000); // 5000 milliseconds (5 seconds)
  // };

  // Logout function with fetch and keepalive
  const handleLogout = () => {
    if (!jwtToken) return;

    fetch(`${webApi}/user/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({}),
      keepalive: true, // Ensures request completes even when tab closes
    })
      .then(() => {
        Cookies.remove("authToken");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click"];

    // const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    //   event.preventDefault();
    //   // event.returnValue = "Are you sure you want to log out?"; // Default browser warning
    // };

    events.forEach((event) => window.addEventListener(event, resetTimer));
    // window.addEventListener("beforeunload", handleBeforeUnload);

    resetTimer();

    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [jwtToken, webApi]);

  return (
    <InactivityContext.Provider
      value={{
        isIdle,
        isStatusChange,
        setIsStatusChange,
        isProfileChange,
        setIsprofileChange,
        selectedClass,
        setSelectedClass,
        selectedBranch,
        setSelectedBranch,
        selectedBranchName,
        setSelectedBranchName,
        selectedClassName,
        setSelectedClassName,
        wizklubPreviousYearselectedBranch,
        setWizklubPreviousYearSelectedBranch,
        wizklubPreviousYearselectedClass,
        setWizklubPreviousYearSelectedClass,
        wizklubPreviousYearselectedBranchName,
        setWizklubPreviousYearSelectedBranchName,
        wizklubPreviousYearselectedClassName,
        setWizklubPreviousYearSelectedClassName,
        wizklubStudentsSelectedAdmissionStatus,
        setWizklubStudentsSelectedAdmissionStatus,
        wizklubStudentsSelectedAdmissionStatusName,
        setWizklubStudentsSelectedAdmissionStatusName,
        wizklubCallBackSelectedClass,
        setWizklubCallBackSelectedClass,
        wizklubCallBackSelectedBranch,
        setWizklubCallBackSelectedBranch,
        wizklubCallBackSelectedBranchName,
        setWizklubCallBackSelectedBranchName,
        wizklubCallBackSelectedClassName,
        setWizklubCallBackSelectedClassName,
        wizklubCallBackSelectedCategory,
        setWizklubCallBackSelectedCategory,
        wizklubCallBackSelectedSubCategory,
        setWizklubCallBackSelectedSubCategory,
        wizklubCallBackSelectedAgent,
        setWizklubCallBackSelectedAgent,
        wizklubCallBackSelectedCategoryName,
        setWizklubCallBackSelectedCategoryName,
        wizklubCallBackSelectedSubCategoryName,
        setWizklubCallBackSelectedSubCategoryName,
        wizklubCallBackSelectedAgentName,
        setWizklubCallBackSelectedAgentName,
        wizklubCompletedSelectedClass,
        setWizklubCompletedSelectedClass,
        wizklubCompletedSelectedBranch,
        setWizklubCompletedSelectedBranch,
        wizklubCompletedSelectedBranchName,
        setWizklubCompletedSelectedBranchName,
        wizklubCompletedSelectedClassName,
        setWizklubCompletedSelectedClassName,
        wizklubCompletedSelectedAgent,
        setWizklubCompletedSelectedAgent,
        wizklubCompletedSelectedAgentName,
        setWizklubCompletedSelectedAgentName,
        wizklubSelectedAgent,
        setWizklubSelectedAgent,
        wizklubSelectedAgentName,
        setWizklubSelectedAgentName,
        wizklubCompletedSelectedCategory,
        setWizklubCompletedSelectedCategory,
        wizklubCompletedSelectedSubCategory,
        setWizklubCompletedSelectedSubCategory,
        wizklubCompletedSelectedCategoryName,
        setWizklubCompletedSelectedCategoryName,
        wizklubCompletedSelectedSubCategoryName,
        setWizklubCompletedSelectedSubCategoryName,
        summerCampSelectedClass,
        setSummerCampSelectedClass,
        summerCampSelectedBranch,
        setSummerCampSelectedBranch,
        summerCampSelectedBranchName,
        setSummerCampSelectedBranchName,
        summerCampSelectedClassName,
        setSummerCampSelectedClassName,
        summerCampPendingSelectedClass,
        setSummerCampPendingSelectedClass,
        summerCampPendingSelectedBranch,
        setSummerCampPendingSelectedBranch,
        summerCampPendingSelectedBranchName,
        setSummerCampPendingSelectedBranchName,
        summerCampPendingSelectedClassName,
        setSummerCampPendingSelectedClassName,
        summerCampTargetsSelectedClass,
        setSummerCampTargetsSelectedClass,
        summerCampTargetsSelectedBranch,
        setSummerCampTargetsSelectedBranch,
        summerCampTargetsSelectedBranchName,
        setSummerCampTargetsSelectedBranchName,
        summerCampTargetsSelectedClassName,
        setSummerCampTargetsSelectedClassName,
        summerCampCallBackSelectedClass,
        setSummerCampCallBackSelectedClass,
        summerCampCallBackSelectedBranch,
        setSummerCampCallBackSelectedBranch,
        summerCampCallBackSelectedBranchName,
        setSummerCampCallBackSelectedBranchName,
        summerCampCallBackSelectedClassName,
        setSummerCampCallBackSelectedClassName,
        summerCampCallBackSelectedCategory,
        setSummerCampCallBackSelectedCategory,
        summerCampCallBackSelectedSubCategory,
        setSummerCampCallBackSelectedSubCategory,
        summerCampCallBackSelectedAgent,
        setSummerCampCallBackSelectedAgent,
        summerCampCallBackSelectedCategoryName,
        setSummerCampCallBackSelectedCategoryName,
        summerCampCallBackSelectedSubCategoryName,
        setSummerCampCallBackSelectedSubCategoryName,
        summerCampCallBackSelectedAgentName,
        setSummerCampCallBackSelectedAgentName,
        wizklubSalesSelectedClass,
        setWizklubSalesSelectedClass,
        wizklubSalesSelectedBranch,
        setWizklubSalesSelectedBranch,
        wizklubSalesSelectedBranchName,
        setWizklubSalesSelectedBranchName,
        wizklubSalesSelectedClassName,
        setWizklubSalesSelectedClassName,
        wizklubSalesSelectedAgent,
        setWizklubSalesSelectedAgent,
        wizklubSalesSelectedAgentName,
        setWizklubSalesSelectedAgentName,
        summerCampCompletedSelectedClass,
        setSummerCampCompletedSelectedClass,
        summerCampCompletedSelectedBranch,
        setSummerCampCompletedSelectedBranch,
        summerCampCompletedSelectedBranchName,
        setSummerCampCompletedSelectedBranchName,
        summerCampCompletedSelectedClassName,
        setSummerCampCompletedSelectedClassName,
        summerCampCompletedSelectedAgent,
        setSummerCampCompletedSelectedAgent,
        summerCampCompletedSelectedAgentName,
        setSummerCampCompletedSelectedAgentName,
        summerCampCompletedSelectedCategory,
        setSummerCampCompletedSelectedCategory,
        summerCampCompletedSelectedSubCategory,
        setSummerCampCompletedSelectedSubCategory,
        summerCampCompletedSelectedCategoryName,
        setSummerCampCompletedSelectedCategoryName,
        summerCampCompletedSelectedSubCategoryName,
        setSummerCampCompletedSelectedSubCategoryName,
        wizklubSalesState,
        setWizklubSalesState,
        wizklubSalesZone,
        setWizklubSalesZone,
        wizklubSalesStateName,
        setWizklubSalesStateName,
        wizklubSalesZoneName,
        setWizklubSalesZoneName,
      }}
    >
      {children}
    </InactivityContext.Provider>
  );
};
